import { Snackbar, Fade, Slide, Grow, Box, Typography, Alert } from '@mui/material'
import { useEffect, useState } from 'react'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import ErrorIcon from '@mui/icons-material/Error'

const SlideTransition = (props) => {
  return <Slide {...props} direction="down" />
}

const GrowTransition = (props) => {
  return <Grow {...props} />
}

const EvaluationSnackBar = ({
  message,
  autoHideDuration,
  TransitionComponent = Fade,
  icon,
  status,
  sx,
  showError,
  setShowError,
}) => {
  const [open, setOpen] = useState(true)
  const handleClose = (reason) => {
    if (reason === 'clickaway') {
      return
    }
    setOpen(false)
    setShowError(false)
  }

  useEffect(() => {
    if (!showError) {
      setOpen(true)
    }
  }, [showError])

  return (
    <Box>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={!open ? open : showError}
        TransitionComponent={
          TransitionComponent === 'slide'
            ? SlideTransition
            : TransitionComponent === 'grow'
            ? GrowTransition
            : Fade
        }
        autoHideDuration={autoHideDuration}
        onClose={handleClose}
      >
        <Alert
          sx={{ display: 'flex', alignItems: 'center', ...sx }}
          color={status === 'error' ? 'error' : 'dark-text'}
          variant="filled"
          icon={
            icon ? (
              icon
            ) : status === 'error' ? (
              <ErrorIcon sx={{ fontSize: 20, color: 'white' }} />
            ) : status === 'success' ? (
              <CheckCircleIcon sx={{ fontSize: 20, color: 'positive.main' }} />
            ) : (
              false
            )
          }
        >
          {typeof message === 'object' ? (
            <Typography color="white.main">{message}</Typography>
          ) : typeof message === 'string' ? (
            <Typography color="white.main">{message}</Typography>
          ) : null}
        </Alert>
      </Snackbar>
    </Box>
  )
}

export default EvaluationSnackBar
